import React,{useState, useEffect} from "react";
import Offcanvas from "./Offcanvas";
import Dropdown from 'react-bootstrap/Dropdown';
import moment from 'moment'
import { COMPANY_LOGO_PATH } from "../../../constants/Config.js";
import magmaLogo from "../../../assets/images/magma_logo.png"
import hambargar_menu from "../../../assets/images/hambargar_menu.svg"
import profile_photo from "../../../assets/images/profileAvtar.png"
import { useDispatch,useSelector } from "react-redux";
import {clearLocalStorageAndLogout} from '../../../store/actions/AuthAction'
import {getPostData} from '../../../store/actions/CommonAction'
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom"

const Header = (props) => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const dispatch = useDispatch();
    const profile = useSelector(state => state.auth.userDetail)
    const [currentDate, setCurrentDate] = useState(Date.now())
    const [flashMessages, setFlashMessages] = useState([])
    const location = useLocation();

	useEffect(() => {

        if(location.pathname.includes('/dashboard')){
            //alert()
        }
        getFlashMessages()
		const interval = setInterval(() => setCurrentDate(Date.now()), 1000);
		return () => {
		  clearInterval(interval);
		};
	  }, []);
    

    const handleLogOut =()=>{
        dispatch(clearLocalStorageAndLogout({'empCode':profile?.employeeCode}))
    }

    const getFlashMessages =()=>{
        getPostData('getFlashMessage').then(res=>{
            if (res.error) {
                toast.error(res.msg);
              } else {
                setFlashMessages(res.data)
              }
        })
    }

    return (
        <>
        <div className="header_box">
            <div className='container header_box_inner p-0'>
                <div className="left_header">
                    <button className="btn btn-primary hambargar_menu " type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                        <img src={hambargar_menu} className="" loading="lazy" alt="" />
                    </button>
                    {
                        isSafari ? <img src={magmaLogo} className="" loading="lazy" alt="" />:
                        <img src={COMPANY_LOGO_PATH} className="" loading="lazy" alt="" width={"205px"}/>
                    }
                    {
                        flashMessages.length > 0 && 
                        <div className="marqueDiv">
                        <marquee width="100%" direction="left" style={{marginRight:'50px'}}>
                            {
                              flashMessages.map((message,index)=>(
                                <>
                                <span style={{color:'red',fontWeight:600}}>{message.flashMessage}</span> <span className="marqueBullet"></span>&nbsp;
                                </>
                                
                              ))  
                            }
                       
                        </marquee>
                        </div>
                    }
                    {/* {
                        flashMessages.length > 0 && 
                        
                         <marquee width="100%" direction="left" style={{marginLeft:'50px'}}>
                            <div className="marqueOuter">
                            {
                              flashMessages.map((message,index)=>(
                                <>
                                <span style={{color:'red',fontWeight:700,fontSize:16, fontFamily:'sans-serif'}}>{message.flashMessage}</span> <span className="marqueBullet"></span>
                                </>
                                
                              ))  
                            }
                        </div>
                         </marquee>
                        
                    } */}
                    
                   
                </div>
                <div className="right_header">
                    <div className="date_time"><span>{moment(currentDate).format('Do MMM YYYY')}</span>{moment(currentDate).format('h:mm a')}</div>
                    <Dropdown className="header_dropdown welcomeButton">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                    <div className="d-flex">
                        <img src={profile_photo} className="Dashboard_icon" loading="lazy" alt="" style={{height:43,width:43}}/>
                    </div>
                    <div className="welcome_header">
                        <ul>
                            <li>Welcome {profile.employeeName.split(" ")[0]}</li>
                            <li>Emp Code: {profile.employeeCode}</li>
                        </ul>
                    </div>
                    </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item href="#" onClick={()=>handleLogOut()}>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
        </div>
        
        <Offcanvas sideBarActive={props.sideBarActive}/>
        </>
    )
}

export default Header